import { format } from "date-fns";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import { IoEyeSharp } from "react-icons/io5";
import { RxCross1 } from "react-icons/rx";
import useAuthToken from "../../../../hooks/useAuthToken";
import styles from "./css/ProductTable.module.scss";
import FeedbackModal from "./FeedbackModel";

const ProductTable = ({
  apiEndpoint,
  rows,
  feedbacks,
  setFeedbacks,
  currentPage,
  setCurrentPage,
  sortField,
  sortOrder,
  setSortField,
  setSortOrder,
  loading,
  setLoading,
}) => {
  const { token } = useAuthToken();
  const [products, setProducts] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  // const navigate = useNavigate();

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        setLoading(true);
        const response = await fetch(apiEndpoint, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setProducts(data.data.feedback);
        setFeedbacks(data.data.feedback);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (!loading) {
      fetchFeedback();
    }
  }, [apiEndpoint, rows, token]);

  const columns = [
    {
      field: "id",
      header: "Sr No.",
      className: styles["column-id"],
      sortable: true,
    },
    {
      field: "feedback_user.firstname",
      header: "User Name",
      className: styles["column-firstname"],
      sortable: true,
    },
    // {
    //   field: "title",
    //   header: "Title",
    //   className: styles["column-title"],
    //   sortable: true,
    //   body: (rowData) => (
    //     <span className={styles["description-text"]}>
    //       {truncateText(rowData.title)}
    //     </span>
    //   ),
    // },
    {
      field: "description",
      header: "Feedback",
      className: styles["column-description"],
      body: (rowData) => {
        return (
          <span className={styles["description-text"]}>
            <IoEyeSharp onClick={() => setSelectedFeedback(rowData)} />
            {truncateText(rowData.description)}
          </span>
        );
      },
      sortable: true,
    },
    {
      field: "ratting",
      header: "Rating",
      className: styles["column-rating"],
      body: (rowData) => renderStars(rowData.ratting),
      sortable: true,
    },
    {
      field: "created_at",
      header: "Date",
      className: styles["column-date"],
      body: (rowData) => format(new Date(rowData.created_at), "dd-MM-yyyy"),
      sortable: true,
    },
  ];

  const closePopup = () => {
    setShowPopup(false);
    setPopupText("");
  };

  const handlePageChange = (event) => {
    setCurrentPage(event.page + 1);
  };

  const handleSort = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder === 1 ? "ASC" : "DESC");
    setCurrentPage(1);
  };

  // print stars in rating section
  const renderStars = (rating) => {
    if (!rating || rating < 1 || rating > 5) return "No Rating";
    return (
      <>
        {Array.from({ length: rating }).map((_, index) => (
          <FaStar key={index} color="#e94057" />
        ))}
      </>
    );
  };

  // Helper function to truncate text to a specific number of words
  const truncateText = (text) => {
    const words = text.split(" ");
    return words.length > 3 ? words.slice(0, 3).join(" ") + "..." : text;
  };

  return (
    <>
      <div className={`${styles.main}`}>
        <DataTable
          className={`${styles.datatable}`}
          value={feedbacks}
          rows={rows}
          first={(currentPage - 1) * rows}
          onPage={handlePageChange}
          totalRecords={feedbacks.length}
          sortField={sortField}
          sortOrder={sortOrder === "ASC" ? 1 : -1}
          onSort={handleSort}
          emptyMessage={
            loading ? (
              <div className={styles.loading_row}>
                <div className={styles.spinner}></div>
              </div>
            ) : (
              <div className={styles["no-data-message"]}>
                No data to display.
              </div>
            )
          }
        >
          {columns.map((col, i) => (
            <Column
              key={i}
              field={col.field}
              header={col.header}
              sortable={col.sortable}
              headerClassName={`${styles["column-header-small"]} ${col.className}`}
              bodyClassName={col.className}
              body={col.body}
              handleSort={handleSort}
            />
          ))}
        </DataTable>
      </div>

      {/* pop-up for description */}
      {showPopup && (
        <div className={styles.popupOverlay} onClick={closePopup}>
          <div className={styles.popupBox} onClick={(e) => e.stopPropagation()}>
            <div className={styles.popupContent}>
              <p>{popupText}</p>
              <RxCross1 className={styles.closeButton} onClick={closePopup} />
            </div>
          </div>
        </div>
      )}

      <FeedbackModal
        feedback={selectedFeedback}
        onClose={() => setSelectedFeedback(null)}
      />
    </>
  );
};

export default ProductTable;
